import React, { Component } from 'react';

const defaultProps = {
  region: null,
  onCommunityClick: () => {},
  onRegionClick: () => {},
  headline: ''
};

class AdditionalCustomerCenter extends Component {
  render() {
    const { region } = this.props;
    return (
      <div className="additional_customer_center">
        <br />
        <b>{this.props.headline}</b>&nbsp;
        <div className="additional_customer_center_links">
          <button
            onClick={e => {
              e.preventDefault();
              this.props.onRegionClick(region.region);
            }}
          >
            {region.region}
          </button>
          ,&nbsp;
          <button
            onClick={e => {
              e.preventDefault();
              this.props.onCommunityClick(region.region, region.community, region.zip);
            }}
          >
            {region.community}
          </button>
        </div>
      </div>
    );
  }
}

AdditionalCustomerCenter.defaultProps = defaultProps;

export default AdditionalCustomerCenter;
